export enum unitLength {
    nm = "nm",
    mikrom = "μm",
    mm = "mm",
    cm = "cm",
    dm = "dm",
    m = "m",
    km = "km",
    inch = "in",
    ft = "ft",
    yd = "yd",
    mi = "mi",
    NM = "NM",
    au = "au",
    lokiec = "ł",
  }
  export enum unitLengthLabels {
    nm = "Nanometry",
    mikrom = "Mikrometry",
    mm = "Milimetry",
    cm = "Centymetry",
    dm = "Decymetry",
    m = "Metry",
    km = "Kilometry",
    inch = "Cale",
    ft = "Stopy",
    yd = "Jardy",
    mi = "Mile",
    NM = "Mile morskie",
    au = "Jednostka astronomiczna",
    lokiec = "Łokcie staropolskie",
};
export enum unitArea {
    nm2 = "nm²",
    mikrom2 = "μm²",
    mm2 = "mm²",
    cm2 = "cm²",
    dm2 = "dm²",
    m2 = "m²",
    km2 = "km²",
    inch2 = "in²",
    ft2 = "ft²",
    yd2 = "yd²",
    mi2 = "mi²",
    ac = "ac",
    a = "a",
    ha = "ha",
    morga = "m",
}
export enum unitAreaLabels {
    nm2 = "Nanometry kwadratowe",
    mikrom2 = "Mikrometry kwadratowe",
    mm2 = "Milimetry kwadratowe",
    cm2 = "Centymetry kwadratowe",
    dm2 = "Decymetry kwadratowe",
    m2 = "Metry kwadratowe",
    km2 = "Kilometry kwadratowe",
    inch2 = "Cale kwadratowe",
    ft2 = "Stopy kwadratowe",
    yd2 = "Jardy kwadratowe",
    mi2 = "Mile kwadratowe",
    ac = "Akry",
    a = "Ary",
    ha = "Hektary",
    morga = "Morgi nowopolskie:",
};
export enum unitVolume {
    nm3 = "nm³",
    mikrom3 = "μm³",
    mm3 = "mm³",
    cm3 = "cm³",
    dm3 = "dm³",
    m3 = "m³",
    km3 = "km³",
    inch3 = "in³",
    ft3 = "ft³",
    yd3 = "yd³",
    mi3 = "mi³",
    acft = "ac-ft",
    mikrol = "μl",
    ml = "ml",
    cl = "cl",
    dl = "dl",
    l = "l",
    hl = "hl",
    gal = "gal",
    bo = "bo",

}
export enum unitVolumeLabels {
    nm3 = "Nanometry sześcienne",
    mikrom3 = "Mikrometry sześcienne",
    mm3 = "Milimetry sześcienne",
    cm3 = "Centymetry sześcienne",
    dm3 = "Decymetry sześcienne",
    m3 = "Metry sześcienne",
    km3 = "Kilometry sześcienne",
    inch3 = "Cale sześcienne",
    ft3 = "Stopy sześcienne",
    yd3 = "Jardy sześcienne",
    mi3 = "Mile sześcienne",
    acft = "Akr-stopy",
    mikrol = "Mikrolitry",
    ml = "Mililitry",
    cl = "Centylitry",
    dl = "Decylitry",
    l = "Litry",
    hl = "Hektolitry",
    gal = "Galon amerykański",
    bo = "Baryłka ropy naftowej",
};
export enum unitTime {
    ns = "ns",
    mikros = "μs",
    ms = "ms",
    s = "s",
    q = "q",
    t = "t",
    min = "min",
    h = "h",
    d = "dni",
    tyg = "tyg",
    m = "m",
    lat = "lat",
    dek = "dek",
    wiek = "w",
    tys = "mill",
}
export enum unitTimeLabels {
    ns = "Nanosekundy",
    mikros = "Mikrosekundy",
    ms = "Milisekundy",
    s = "Sekundy",
    q = "Kwarty",
    t = "Tercje",
    min = "Minuty",
    h = "Godziny",
    d = "Dni",
    tyg = "Tygodnie",
    m = "Miesiące (średnia)",
    lat = "Lata (średnia)",
    dek = "Dekady",
    wiek = "Wieki",
    tys = "Tysiąclecia",
};
export enum unitWeight {
    ng = "ng",
    mikrog = "μg",
    mg = "mg",
    cg = "cg",
    dg = "dg",
    g = "g",
    dag = "dag",
    kg = "kg",
    Mg = "Mg",
    t = "t",
    gr = "gr",
    oz = "oz",
    lb = "lb",
    st = "st",
    cwt = "cwt",
    ct = "ct",
    cwtPL = "c",
  }
  export enum unitWeightLabels {
    ng = "Nanogramy",
    mikrog = "Mikrogramy",
    mg = "Miligramy",
    cg = "Centygramy",
    dg = "Decygramy",
    g = "Gramy",
    dag = "Dekagramy",
    kg = "Kilogramy",
    Mg = "Megagramy",
    t = "Tony",
    gr = "Grany (ziarna)",
    oz = "Uncje",
    lb = "Funty",
    st = "Kamienie",
    cwt = "Cetnary angielskie",
    ct = "Karaty",
    cwtPL = "Cetnary warszawskie",
};
export enum unitInformation {
    b = "b",
    B = "B",
    kbSI = "kb",
    MbSI = "Mb",
    GbSI = "Gb",
    TbSI = "Tb",
    kBSI = "kB",
    MBSI = "MB",
    GBSI = "GB",
    TBSI = "TB",
    Kib = "Kib",
    Mib = "Mib",
    Gib = "Gib",
    Tib = "Tib",
    KiB = "KiB",
    MiB = "MiB",
    GiB = "GiB",
    TiB = "TiB",
    KbJEDEC = "Kb ",
    MbJEDEC = "Mb ",
    GbJEDEC = "Gb ",
    TbJEDEC = "Tb ",
    KBJEDEC = "KB ",
    MBJEDEC = "MB ",
    GBJEDEC = "GB ",
    TBJEDEC = "TB ",
}
export enum unitInformationLabels {
    b = "Bity",
    B = "Bajty",
    kbSI = "Kilobity",
    MbSI = "Megabity",
    GbSI = "Gigabity",
    TbSI = "Terabity",
    kBSI = "Kilobajty",
    MBSI = "Megabajty",
    GBSI = "Gigabajty",
    TBSI = "Terabajty",
    Kib = "Kibibity",
    Mib = "Mebibity",
    Gib = "Gibibity",
    Tib = "Tebibity",
    KiB = "Kibibajty",
    MiB = "Mebibajty",
    GiB = "Gibibajty",
    TiB = "Tebibajty",
    KbJEDEC = "Kilobity",
    MbJEDEC = "Megabity",
    GbJEDEC = "Gigabity",
    TbJEDEC = "Terabity",
    KBJEDEC = "Kilobajty",
    MBJEDEC = "Megabajty",
    GBJEDEC = "Gigabajty",
    TBJEDEC = "Terabajty",
}
export enum unitSpeed {
    mps = "m/s",
    kph = "km/h",
    mph = "mi/h",
    kn = "kn",
    ftps = "ft/s",
    ss = "v",
    c = "c",
}
export enum unitSpeedLabels {
    mps = "Metry na sekundę",
    kph = "Kilometry na godzinę",
    mph = "Mile na godzinę",
    kn = "Węzły",
    ftps = "Stopy na sekundę",
    ss = "Prędkości dźwięku",
    c = "Prędkości światła",

}

